import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import getJwt from "../../../../utils/getJwt";

export const createResponse = async (
  surveyId,
  userId,
  locale,
  payload,
  metadata,
  sessionId
) => {
  if (isEmpty(userId))
    return API.post("surveys", `/surveys/${surveyId}/responses`, {
      body: {
        locale,
        payload,
        ...metadata,
        sessionId,
      },
    });

  const jwt = await getJwt();

  return API.post("surveys", `/users/${userId}/surveys/${surveyId}/responses`, {
    body: {
      locale,
      payload,
      ...metadata,
      sessionId,
    },
    headers: { Authorization: `Bearer ${jwt}` },
  });
};

export const getPayload = async (surveyId, userId, responseId) => {
  if (isEmpty(userId))
    return API.get("surveys", `/surveys/${surveyId}/responses/${responseId}`);

  const jwt = await getJwt();

  return API.get(
    "surveys",
    `/users/${userId}/surveys/${surveyId}/responses/${responseId}`,
    {
      headers: { Authorization: `Bearer ${jwt}` },
    }
  );
};

export const getUserResponses = async (surveyId, userId) => {
  const jwt = await getJwt();

  return API.get("surveys", `/users/${userId}/surveys/${surveyId}/responses`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
};

export const getUserHistory = async (surveyId, userId) => {
  const jwt = await getJwt();

  return API.get("surveys", `/users/${userId}/surveys/${surveyId}/history`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
};
